(() => {
  'use strict';
  if (window.cngHeritageHeadsInitialized) return;
  window.cngHeritageHeadsInitialized = true;

  const intentKey = 'cng_hh_offer_intent_v2';
  const accountSeenKey = 'cng_hh_account_offer_seen_v3';
  const intentLifetime = 30 * 60 * 1000;
  let signedIn = false;
  let shopifySignedIn = false;
  let loggingOut = false;
  let stateRequest;
  let returnFocus;
  let previousOverflow;
  const controller = () => document.querySelector('[data-heritage-heads-controller]');
  const dialog = () => document.getElementById('HeritageHeadsModal');

  function hasVerifiedKwikSession() {
    try {
      if (sessionStorage.getItem('isLogout') === 'true') return false;
      const raw = sessionStorage.getItem('kp_session_type');
      const sessionType = raw?.startsWith('"') ? JSON.parse(raw) : raw;
      if (sessionType !== 'verified') return false;
      if (typeof window.getValueFromCookiesOrLocalStorage !== 'function') return false;
      const read = window.getValueFromCookiesOrLocalStorage;
      const coreKey = typeof window.XGokwikCoreToken === 'function'
        ? window.XGokwikCoreToken(window.merchantInfo?.environment) : null;
      const uniKey = typeof window.XGokwikUniToken === 'function' ? window.XGokwikUniToken() : null;
      return Boolean((coreKey && read(coreKey)) || (uniKey && read(uniKey)));
    } catch (_) {
      return false;
    }
  }

  function syncLoginState() {
    updateStrips(!loggingOut && (shopifySignedIn || hasVerifiedKwikSession()));
    document.querySelectorAll('[data-hh-account-offer]').forEach((offer) => { offer.hidden = !signedIn; });
    if (signedIn) resumeAccountOffer();
    else if (dialog()?.open && !dialog().querySelector('[data-hh-coupon]').hidden) closeOffer();
  }

  function updateStrips(value) {
    signedIn = value;
    document.querySelectorAll('[data-heritage-heads-strip]').forEach((strip) => {
      strip.querySelector('[data-hh-guest]').hidden = value;
      strip.querySelector('[data-hh-member]').hidden = !value;
    });
  }

  function closeOffer() {
    const modal = dialog();
    if (modal?.open) modal.close();
  }

  function openOffer(coupon = false) {
    const modal = dialog();
    if (!modal || typeof modal.showModal !== 'function') return false;
    modal.querySelector('[data-hh-teaser]').hidden = coupon;
    modal.querySelector('[data-hh-coupon]').hidden = !coupon;
    const title = modal.querySelector('[data-hh-title]');
    title.textContent = coupon ? title.dataset.couponTitle : title.dataset.signupTitle;
    if (!modal.open) {
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      modal.showModal();
      document.body.style.overflow = 'hidden';
      modal.querySelector('[data-hh-close]').focus();
    }
    return true;
  }

  function resumeAccountOffer() {
    const config = controller();
    if (!config || config.dataset.accountPage !== 'true' || !signedIn) return;
    try {
      const startedAt = Number(sessionStorage.getItem(intentKey));
      const age = Date.now() - startedAt;
      const fromOffer = startedAt > 0 && age >= 0 && age < intentLifetime;
      if (!fromOffer) {
        sessionStorage.removeItem(intentKey);
        return;
      }
      if (openOffer(true)) {
        sessionStorage.removeItem(intentKey);
      }
    } catch (_) {}
  }

  async function refreshCustomerState() {
    const config = controller();
    if (!config) return;
    stateRequest?.abort();
    const request = new AbortController();
    stateRequest = request;
    const timeout = window.setTimeout(() => request.abort(), 5000);
    try {
      const url = new URL(config.dataset.stateUrl, window.location.origin);
      url.searchParams.set('_hh', String(Date.now()));
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store', signal: request.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = html.querySelector('[data-heritage-heads-customer-state]');
      if (!state || controller() !== config || stateRequest !== request) return;
      shopifySignedIn = state.dataset.signedIn === 'true';
      syncLoginState();
    } catch (_) {
      // Keep Shopify's initial server-rendered state if verification is unavailable.
    } finally {
      clearTimeout(timeout);
    }
  }

  async function copyCode(button) {
    const card = button.closest('.heritage-heads-coupon');
    const status = card.querySelector('[data-hh-copy-status]');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(button.dataset.hhCopy);
      status.textContent = button.dataset.copiedLabel;
    } catch (_) {
      status.textContent = button.dataset.errorLabel;
      const selection = window.getSelection();
      if (selection) {
        const range = document.createRange();
        range.selectNodeContents(card.querySelector('.heritage-heads-code'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const action = target?.closest('[data-hh-open-signup], [data-hh-open-coupon], [data-hh-login], [data-hh-close], [data-hh-copy]');
    if (!action) {
      if (event.target === dialog()) {
        const bounds = dialog().getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeOffer();
      }
      return;
    }
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (action.matches('[data-hh-open-signup], [data-hh-open-coupon]')) {
      if (openOffer(signedIn)) event.preventDefault();
    } else if (action.matches('[data-hh-login]')) {
      try { sessionStorage.setItem(intentKey, String(Date.now())); } catch (_) {}
      closeOffer();
      const config = controller();
      if (config && typeof window.handleKpAndShopifyLogin === 'function') {
        event.preventDefault();
        try {
          window.handleKpAndShopifyLogin(config.dataset.accountUrl);
        } catch (_) {
          window.location.assign(action.href);
        }
      }
    } else if (action.matches('[data-hh-close]')) {
      event.preventDefault();
      closeOffer();
    } else if (action.matches('[data-hh-copy]')) {
      event.preventDefault();
      void copyCode(action);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.id !== 'HeritageHeadsModal') return;
    document.body.style.overflow = previousOverflow || '';
    if (returnFocus?.isConnected) returnFocus.focus();
  }, true);

  function initialize() {
    const config = controller();
    if (!config) return;
    shopifySignedIn = config.dataset.signedIn === 'true';
    syncLoginState();
    void refreshCustomerState();
  }

  function onSessionChange() {
    syncLoginState();
    void refreshCustomerState();
  }

  window.addEventListener('pageshow', onSessionChange);
  window.addEventListener('user-loggedin', () => { loggingOut = false; onSessionChange(); });
  window.addEventListener('update-dom', onSessionChange);
  window.addEventListener('storage', onSessionChange);
  window.addEventListener('close_popup', () => {
    if (!shopifySignedIn && !hasVerifiedKwikSession()) {
      try { sessionStorage.removeItem(intentKey); } catch (_) {}
    }
  });
  window.addEventListener('kp_user_logged_out', () => {
    loggingOut = true;
    shopifySignedIn = false;
    try {
      sessionStorage.removeItem(intentKey);
    } catch (_) {}
    syncLoginState();
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
